export const enum LocalStorageManagerKeys {
    GB_UUID = "GB_UUID",
    EMAIL = "ZING_WEB_EMAIL",
    USER_UUID = "ZING_WEB_USER_UUID",
    IS_AUTH_STEP = "IS_AUTH_STEP",
    IS_SKIP_BODY_SCAN = "IS_SKIP_BODY_SCAN",
    IS_SKIP_NUTRITION_BOOK = "IS_SKIP_NUTRITION_BOOK",
    IS_AUTH_PASSED = "IS_AUTH_PASSED",
    IS_PAYWALL_STEP = "IS_PAYWALL_STEP",
    ANSWERS = "ZING_ANSWERS",
    EXTERNAL_ID = "AD_SIDE_CUSTOMER_ID",
    BOUGHT_PLAN_IDENT = "ZING_BOUGHT_PLAN_IDENT",
    PAYMENT_METHOD = "ZING_PAYMENT_METHOD",
    IS_PURCHASED_WITH_BODY_SCAN = "IS_PURCHASED_WITH_BODY_SCAN",
    NAME = "ZING_USER_NAME",
    GEOLOCATION_DATA = "ZING_GEOLOCATION_DATA",
    AGE_GROUP_DECADE = "ZING_AGE_GROUP_DECADE",
    PROMO_CODE = "PROMO_CODE",
    PROMO_CODE_RESERVE_DATA = "PROMO_CODE_RESERVE_DATA",
    IS_ADDITIONAL_DISCOUNT = "IS_ADDITIONAL_DISCOUNT",
    AGE_GROUP = "ZING_AGE_GROUP",
}

const storeItem = (key: LocalStorageManagerKeys, value: unknown): void => {
    if (value === undefined) return;
    if (value) {
        try {
            const data = JSON.stringify(value);
            localStorage.setItem(key, data);
        } catch (e) {
            console.error(e);
        }
    } else {
        localStorage.removeItem(key);
    }
};

const removeItem = (key: LocalStorageManagerKeys): void => {
    localStorage.removeItem(key);
};

const getStoredItem = <T>(key: LocalStorageManagerKeys): T | null => {
    const data = localStorage.getItem(key);
    if (data) {
        try {
            return JSON.parse(data) as T;
        } catch (e) {
            console.error(e);
        }
    }
    return null;
};

export const localStorageManager = {
    storeItem,
    removeItem,
    getStoredItem,
};
